import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ERole } from 'src/app/shared/roles/models/role.enum';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RoleRepository {

  private readonly rolesUrl: string = `${environment.apiUrl}/roles.json`;

  constructor(private http: HttpClient) { }

  public getRoles(): Observable<Array<ERole>> {
    return this.http.get<Array<ERole>>(this.rolesUrl);
  }
}
